<template>
  <div class="flex flex-col">
    <H4 class="font-semibold mb-6">
      {{ name }}
    </H4>
    <div>
      <body
        :class="[
          'text-sm rounded-sm px-8 font-semibold py-2 inline',
          gender === 'm' ? 'bg-blue-200' : 'bg-purple-200',
        ]"
      >
        {{ gender === 'm' ? 'MALE' : 'FEMALE' }}
      </body>
    </div>
  </div>
</template>

<script>
import H4 from '~/components/common/Typography/H4.vue'
import Body from '~/components/common/Typography/Body.vue'

export default {
  components: {
    H4,
    Body,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    gender: {
      type: String,
      required: true,
    },
  },
}
</script>
